import { render, staticRenderFns } from "./orginfo.vue?vue&type=template&id=6b1b2c8f"
import script from "./orginfo.vue?vue&type=script&lang=js"
export * from "./orginfo.vue?vue&type=script&lang=js"
import style0 from "./orginfo.vue?vue&type=style&index=0&id=6b1b2c8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports